import { ActionPreview } from '../../../api/newsfeed.types'
import { ActionsAllAction } from './actions.all.types'

export const actionsAllRequestAction = (): ActionsAllAction => ({ type: 'ACTIONS_ALL_REQUEST' })
export const actionsAllSuccessAction = (actions: ActionPreview[]): ActionsAllAction => ({ type: 'ACTIONS_ALL_SUCCESS', params: actions })
export const actionsAllFailureAction = (error?: any): ActionsAllAction => ({ type: 'ACTIONS_ALL_FAILURE', params: error })